import {Int, positive, Schema} from 'effect/Schema';

export const OperationId = Int.pipe(positive()) as unknown as Schema<OperationId>;
export type OperationId = import('../src/OperationId').OperationId;
